module.exports = __webpack_public_path__ + "img/checked.059a7265.svg";